import type React from 'react'

import type { SubscriptionStat } from '@/store/reducers/subscription'
import css from './styles.module.css'

interface Props {
  item: SubscriptionStat
}

export const StatsCard: React.FC<Props> = ({ item: { label, of, count } }) => {
  return (
    <div className={css.stats_card}>
      <span className={css.label}>{label}</span>
      <div className={css.values}>
        <span className={css.count}>{count}</span>
        <span className={css.of}>{of}</span>
      </div>
    </div>
  )
}
